// extracted by mini-css-extract-plugin
export var ratingTitle = "UserReview-mps-module--ratingTitle--8fb0e";
export var reviewCountContent = "UserReview-mps-module--reviewCountContent--bacc3";
export var reviewCountTitle = "UserReview-mps-module--reviewCountTitle--6de67";
export var reviewHeader = "UserReview-mps-module--reviewHeader--90794";
export var reviewIcons = "UserReview-mps-module--reviewIcons--eefe0";